import React, { useState } from "react";

import { Row, Col, Container } from "react-bootstrap";

import { BiSquareRounded } from "react-icons/bi";
import { FiTriangle } from "react-icons/fi";
import { BiCircle } from "react-icons/bi";
import { isMobile } from "react-device-detect";

import videoSim from "../../../../image/home/videoSim.mp4";
import cursorImage from "../../../../image/home/cursorImage.png";

import Ifarme from "../../iframe";

import {
  frameWidth,
  frameHeight,
  SimCoverContent,
  SimCursorContainer,
  StyledSection,
  StyledShapes,
  StyledVideoPlayer,
  TabletWrapper,
} from "./styledTabletSection";

const TabletSectionComponent = () => {
  const [isShowSim, setIsShowSim] = useState(false);

  const handleShowSim = () => {
    setIsShowSim(true);
  };

  return (
    <StyledSection className="pb-4 pb-md-5">
      <Container>
        <Row className="justify-content-evenly flex-nowrap">
          <Col className="px-0">
            <StyledShapes right>
              <FiTriangle size={50} color="#ffaa2a" strokeWidth={3} />
              <BiCircle size={27} color="#2a7FFF" strokeWidth={1.5} />
              <BiSquareRounded size={28} color="#7dcf56" strokeWidth={2} />
            </StyledShapes>
          </Col>
          <Col className="px-0">
            <TabletWrapper isShowSim={isShowSim}>
              {isShowSim ? (
                <Ifarme
                  path="https://dl.azeto.ir/sims/circuit-construction-kit-dc-virtual-lab/circuit-construction-kit-dc-virtual-lab_fa.html"
                  width={frameWidth}
                  height={frameHeight}
                  fullScreenInMobile={isMobile}
                />
              ) : (
                <>
                  <StyledVideoPlayer
                    src={videoSim}
                    loop
                    muted
                    autoPlay
                    width={frameWidth}
                    height={frameHeight}
                  />
                  <SimCoverContent className="text-center" onClick={handleShowSim}>
                    <span>برای شروع</span>
                    <SimCursorContainer>
                      <img
                        src={cursorImage}
                        alt="ورود به شبیه‌ساز"
                        width="33"
                        height="45"
                      />
                    </SimCursorContainer>
                    <span>ضربه بزنید</span>
                  </SimCoverContent>
                </>
              )}
            </TabletWrapper>
            <p className="text-center mt-4">
              <mark>همین حالا</mark>
              شبیه‌ساز آزمایش فیزیک را امتحان کنید.
            </p>
          </Col>
          <Col className="px-0">
            <StyledShapes left>
              <BiSquareRounded size={45} color="#7dcf56" strokeWidth={2} />
              <FiTriangle size={50} color="#ffaa2a" strokeWidth={3} />
              <BiCircle size={39} color="#2a7FFF" strokeWidth={1.5} />
            </StyledShapes>
          </Col>
        </Row>
      </Container>
    </StyledSection>
  );
};

export default TabletSectionComponent;
